import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import EToolTip from '../others/EToolTip';

interface ListToolBarActionsProps {
    onReset: () => void;
    onRefresh: () => void;
    className?: string;
}

const ListToolBarActions = ({ onReset, onRefresh, className = 'ms-1' }: ListToolBarActionsProps) => {
    const { t } = useTranslation('common');

    const handleClick = (fn: () => void) => (e: React.MouseEvent<HTMLButtonElement>) => {
        e.currentTarget.blur();
        fn();
    };

    return (
        <>
            <EToolTip title={t('toolResetList')}>
                <span className={`d-inline-block ${className}`}>
                    <Button
                        className="fs-14 px-2 toolbar-icon-btn"
                        size="sm"
                        onClick={handleClick(onReset)}
                    >
                        <i className="bi bi-arrow-counterclockwise fs-14 p-0"></i>
                    </Button>
                </span>
            </EToolTip>

            <EToolTip title={t('toolRefreshList')}>
                <span className={`d-inline-block ${className}`}>
                    <Button
                        className="fs-14 px-2 toolbar-icon-btn"
                        size="sm"
                        onClick={handleClick(onRefresh)}
                    >
                        <i className="bi bi-arrow-clockwise fs-14 p-0"></i>
                    </Button>
                </span>
            </EToolTip>
        </>
    );
};

export default ListToolBarActions;
